import { Component, Input } from '@angular/core';
import {
    LoadingController,
    NavController,
    NavParams,
    PopoverController
} from 'ionic-angular';
import { Organization } from '../../../../model/organization';
import { Rodeo } from '../../../../model/rodeo';
import { ActionSheetController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';
import { UserSearchPopover } from '../../../../pages/search/user-search';
import { Account } from '../../../../model/account';
import { EntryService } from '../../../../services/entry.service';
import { RodeoEventService } from '../../../../services/rodeoEvent.service';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';

@Component({
    selector: 'page-contestant-entry-report',
    templateUrl: 'report-contestant-entries.html'

})
export class ContestantEntryReport {
    @Input('organization') organization: Organization;

    selectedContestant: Account;
    contestantName: string;
    selectedClasses: string[] = [];
    toDate: string = '';
    fromDate: string = '';

    disciplines: string[] = [];
    rodeoEntries: Rodeo[] = [];

    documentTitle: any;

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    constructor(
        private nav: NavController,
        navParams: NavParams,
        private loadingController: LoadingController,
        private popoverController: PopoverController,
        public actionSheetCtrl: ActionSheetController,
        public alert: AlertMessager,
        private entryService: EntryService,
        private rodeoEventService: RodeoEventService
    ) {
        this.rodeoEventService.getEventTypes()
            .then(data => {
                this.disciplines = ['All'];
                this.disciplines.push(...data as string[]);
            });

        this.selectedClasses = ['All'];

        if (!this.organization)
            this.organization = navParams.get('organization');

        this.rodeoEntries = navParams.get('rodeoEntries');
        this.selectedContestant = navParams.get('selectedContestant');

        if (this.selectedContestant)
            this.contestantName = this.selectedContestant.firstName + ' ' + this.selectedContestant.lastName;

        this.printing = navParams.get('printing');
        this.dataLoaded = this.printing;
    }

    ngAfterContentInit() {
        setTimeout(() => {
            this.load();
        }, 0);
    }

    async load() {
        if (this.selectedContestant)
            await this.loadContestantEntries(this.selectedContestant);

        this.documentTitle = 'User Rodeo Summary';
        this.dataLoaded = true;
    }

    async loadContestantEntries(contestant: Account) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        const loader = await this.loadingController.create({
            content: ("Retrieving contestant entries...")
        });

        await loader.present();

        let searchOptions: any = {};

        searchOptions.organizations = [this.organization];

        if (this.selectedClasses.length > 1 || (this.selectedClasses[0] && this.selectedClasses[0] != 'All'))
            searchOptions.eventTypes = this.selectedClasses;
        else
            searchOptions.eventTypes = [];

        searchOptions.fromDate = this.fromDate;
        searchOptions.toDate = this.toDate;
        searchOptions.searchText = '';

        try {
            this.rodeoEntries = (await this.entryService.getEntries(contestant.id, searchOptions, 0)) as Rodeo[];
            this.rodeoEntries = this.rodeoEntries.filter(x => x.test == false);

            this.rodeoEntries.forEach(rodeo => {
                rodeo.rodeoEvents.forEach(rodeoEvent => {
                    rodeoEvent.registrations.forEach(reg => {
                        if (!reg.run)
                            reg.run = new RodeoEventRun();
    
                        rodeoEvent.schedules.forEach(schedule => {
                            const runs = schedule.runs.filter(x => !x.used &&
                                (x.contestantOne.id === this.selectedContestant.id && (!x.horseOne || x.horseOneId == reg.horseOneId)
                                 || (x.contestantTwo && x.contestantTwo.id === this.selectedContestant.id && (!x.horseTwo || x.horseTwoId == reg.horseTwoId))));
    
                            if (runs != null && runs.length > 0) {
                                runs[0].used = true;
                                reg.run = runs[0];
                                reg.run.scheduleName = schedule.name;
                                reg.run.scheduledDate = schedule.scheduledDate;
                            }
                        });
                    });
                });
            });
        } catch (error) {
            this.alert.showError("Entry Report", "There was an error retrieving entries for the contestant.");
        }

        console.log("rodeoEntries: ", this.rodeoEntries);
        this.dataLoaded = true;
        this.popoverActive = false;

        await loader.dismiss();
    }

    openContestantOneSearch(searchEvent) {
        let callback = (data) => {
            if (data && data.buddies && data.buddies.length > 0) {
                this.selectedContestant = data.buddies[0];
                this.contestantName = this.selectedContestant.firstName + ' ' + this.selectedContestant.lastName;
            }
        }

        this.openUserSearch(searchEvent, 'User Search', callback);
    }

    openUserSearch(searchEvent, title, callback, allowDraw = false, allowTba = false) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: title,
            organization: this.organization,
            allowDraw: allowDraw,
            allowTba: allowTba,
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    ionViewDidEnter() {
        if (this.printing) {
            setTimeout(() => {
                window.document.title = this.documentTitle;
                window.print();
                this.nav.pop();
            }, 0);
        }
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(ContestantEntryReport, {
            organization: this.organization,
            selectedContestant: this.selectedContestant,
            rodeoEntries: this.rodeoEntries,
            printing: true,
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/reports/report-contestant-entries.ts